import { validateProps } from "../../common/types";
import { MAX_MESSAGE_LENGTH } from "../constants";

export default function validate(values: validateProps) {
  let errors = {} as validateProps;

  if (!values["First Name"]) {
    errors["First Name"] = "Name is required";
  }
  if (values["First Name"].length > 50) {
    errors["First Name"] = "Name is limited to 50 characters";
  }
  if (!values.email) {
    errors.email = "Email address is required";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = "Email address is invalid";
  }
  if (!values.message) {
    errors.message = "Message is required";
  }
  if (values.message.length > MAX_MESSAGE_LENGTH) {
    errors.message = `Message length must be fewer than ${MAX_MESSAGE_LENGTH} characters`;
  }
  return errors;
}
